import React, { Fragment, useEffect, useState } from "react";
import { Backdrop, Button, Grid, IconButton, Input, InputAdornment, Typography } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { TextBoxForm } from "components/Input";
import LoginBG from "../../assets/images/Background/LoginBG.jpg";
import yupFormSchemas from "components/FormItem/yupFormSchemas";
import Person2Outlined from '@mui/icons-material/Person2Outlined';
import LockOutlined from "@mui/icons-material/LockOutlined";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { styled } from "@mui/material";
import "./indexLogin.css";
import { FnBlock_UI } from "components/BlockUI";
import { useNavigate } from "react-router-dom";
import { AxiosPost } from "utilities/Axios";
import { AlertTitle } from "config/AlertMsgConfig";
import { SwAlert } from "components";
import { AuthToken } from "config/AxiosConfig";

const ContainerBG = styled("div")({
    background: `url(${LoginBG}) no-repeat center center fixed`,
    WebkitBackgroundSize: "cover",
    MozBackgroundSize: "cover",
    OBackgroundSize: "cover",
    backgroundSize: "cover",
    height: "100vh",
    width: "100%",
    position: "fixed",
    overflowY: "auto",
});

export default function LoginCenter() {
    const [isIconEye, setisIconEye] = useState(false);
    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const navigate = useNavigate();
    const LoginControllerAPI = "Login";

    const objSchema = {
        Username: yupFormSchemas.string("ชื่อผู้ใช้งาน", { required: true }),
        Password: yupFormSchemas.string("รหัสผ่าน", { required: true }),
    };
    const schema = yup.object().shape(objSchema);
    const form = useForm({
        resolver: yupResolver(schema),
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });

    const handleClickShowPassword = () => setisIconEye((show) => !show);
    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const onLogin = () => {
        BlockUI();
        AxiosPost(`${LoginControllerAPI}/onLogin`, { sUsername: form.getValues("Username"), sSecureCode: form.getValues("Password") }, (res) => {
            if (res.StatusCode == 200) {
                AuthToken.set(res.token);
                navigate("/Home");
                UnBlockUI();
            } else {
                UnBlockUI();
                SwAlert.Warning(AlertTitle.Warning, res.Message)
            }
        }, null, null, null, () => { UnBlockUI(); });
    };

    const subFailed = (value) => {
        console.log("Failed", value);
    }

    return (
        <ContainerBG>
            <div className="cLogin">
                <Fragment>
                    <FormProvider {...form}>
                        <Grid item xs={12} md={12} container spacing={3} justifyContent="start" alignItems="start">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <h2 style={{ fontSize: '1.8rem', marginBottom: '20px', color: '#fff', }}>Login</h2>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <TextBoxForm
                                    name="Username"
                                    // label={"Username"}
                                    required={true}
                                    placeholder="Username"
                                    startAdornment={<InputAdornment position="start" style={{ marginRight: '12px' }}><Person2Outlined style={{ color: '#202178' }} /></InputAdornment>}
                                    endAdornment={<InputAdornment position="end"></InputAdornment>}
                                    onKeyPress={(e) => {
                                        if (e.keyCode === 13 || e.keyCode === 9) {
                                            setTimeout(() => {
                                                form.setFocus("Username");
                                            }, 300);
                                        }
                                        else if (e.key === "Enter") {
                                            form.handleSubmit(onLogin, subFailed)(e);
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <TextBoxForm
                                    name="Password"
                                    // label={"Password"}
                                    required={true}
                                    placeholder="Password"
                                    type={isIconEye ? "text" : "password"}
                                    startAdornment={<InputAdornment position="start" style={{ marginRight: '12px' }}><LockOutlined style={{ color: '#202178' }} /></InputAdornment>}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                                edge="end"
                                            >
                                                {isIconEye ? <VisibilityOffIcon style={{ color: '#202178' }} /> : <VisibilityIcon style={{ color: '#202178' }} />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    onKeyPress={(e) => {
                                        if (e.key === "Enter") {
                                            form.handleSubmit(onLogin, subFailed)(e);
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={12} container spacing={2} justifyContent="right" alignItems="start">
                                <Grid item>
                                    <Button id='btnSubmit' variant="contained" style={{ borderRadius: '20px', backgroundColor: '#00d704', borderBottom: '10px' }} onClick={form.handleSubmit(onLogin)} >Login</Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </Fragment>
            </div>
        </ContainerBG>
    );
}
